(function ($) {
  if (!customElements.get('cdz-mega-menu')) {
    var $body = $('body'), $win = $(window);
    customElements.define('cdz-mega-menu', class CdzMegaMenu extends HTMLElement {
      options = {
        hBreakpoint: 768,
        touchText: "Go to <span class=\"cdz-text\">%1<\/span>",
        backText: "<span class=\"cdz-text\">%1<\/span>"
      }
      constructor() {
        super();
        if (this.isVerMenu()) {
          this.prepareVerMenu();
        }
        this.options = $.extend(this.options, this.dataset);
        this.element = $(this);
        this.resTimeout = false;
        this.addEvents();
        this.prepareHtml();
        this.element.removeClass('no-loaded');
      }
      isMobiMenu() {
        return (window.innerWidth < this.options.hBreakpoint) || this.element.parents('.cdz-tg-menu').length;
      }
      addEvents() {
        var self = this, t = false, align = (isSticky) => {
          if (t) clearTimeout(t);
          t = setTimeout(function () {
            isSticky ? self.alignDropdown('.js-align-drop-sticky') : self.alignDropdown('.js-align-drop');
          }, 100);
        };;
        $win.on('cdz_desktop', this.prepareDesk.bind(this))
          .on('cdz_mobile', this.prepareMobi.bind(this));
        document.addEventListener('shopify:block:select', function (event) {
          self.isMobiMenu() ? self.prepareMobi() : self.prepareDesk();
          align($('header.stiky-active').length);
        });
        if (this.isHorMenu()) {
          var ovfT = false;
          $win.on('headerStateChanged ' + winWidthChangedEvent, function (e, isSticky) {
            align(isSticky);
            if (ovfT) clearTimeout(ovfT);
            ovfT = setTimeout(self.hideOverflowingItems.bind(self), (e.type == winWidthChangedEvent) ? 300 : 50);
          });
          this.element.on('menuHideOvf menuPageChanged', () => {
            align($('header.stiky-active').length);
          });
        }
      }
      prepareVerMenu() {
        var id = this.id;
        if (typeof window.cdzVerMenuCopied == 'undefined') {
          window.cdzVerMenuCopied = true;
          var $verWrap = $('[role="vmenu_content"]').first();
          if ($verWrap.length) {
            $(this).clone().removeAttr('id').appendTo($verWrap);
            this.countVerMenu();
            $win.on(winWidthChangedEvent, this.countVerMenu.bind(this));
          }
        }
      }
      countVerMenu() {
        var action = ($('.cdz-menu-ver:visible').length == 1) ? 'addClass' : 'removeClass';
        $('[role="vmenu_title"]').parents('[role="vmenu_wrap"]').first()[action]('one-vmenu');
      }
      prepareHtml() {
        this.isMobiMenu() ? this.prepareMobi() : this.prepareDesk();
        this.alignDropdown('.js-align-drop');
        this.alignVerDropdown();
        this.addTouchLinks();
        if (this.isHorMenu()) {
          this.hideOverflowingItems();
        }
      }
      isHorMenu() {
        return this.dataset.type == '0';
      }
      isVerMenu() {
        return this.dataset.type == '1';
      }
      isRtl() {
        return $body.attr('dir') === 'rtl';
      }
      isFullMenu() {
        return this.element.hasClass('mn-full');
      }
      prepareMobi() {
        var self = this;
        if (this.resTimeout) clearTimeout(this.resTimeout);
        self.element.removeClass('no-loaded').addClass('cdz-m-menu').removeClass('cdz-d-menu').find('> .js-items > .mn-item > .mn-items').css({ left: '', right: '', top: '' });
      }
      prepareDesk() {
        var self = this;
        if (this.resTimeout) clearTimeout(this.resTimeout);
        self.element.removeClass('cdz-m-menu').addClass('cdz-d-menu');
        if (self.isMobiMenu()) {
          self.prepareMobi();
        } else {
          self.element.addClass('no-loaded');
          this.resTimeout = setTimeout(() => {
            if (self.isHorMenu()) {
              self.hideOverflowingItems();
            }
            self.element.removeClass('no-loaded');
          }, 100);
        }
      }
      alignDropdown(alignSl) {
        if (this.isHorMenu()) {
          var $el = $(this), $alignCont = $el.parents(alignSl).first(), isFull = this.isFullMenu(), isRtl = this.isRtl();;
          if ($alignCont.length === 0) $alignCont = $el.parent();
          var acWidth = $alignCont.outerWidth(),
            acLeft = $alignCont.offset().left,
            acPad = parseFloat($alignCont.css('padding-right')),
            acRight = acLeft + acWidth - acPad;
          $el.find('> .js-items > .mn-item > .mn-items').css({ left: '', right: '' }).each(function () {
            var $drop = $(this).css({ display: 'block', opacity: 0, visibility: 'hidden' });
            if (isFull && (!$drop.parent().hasClass('cdz-tree-wrap'))) {
              if (isRtl) {
                $drop.css({ right: $drop.offset().left });
              } else {
                $drop.css({ left: -$drop.parent().offset().left });
              }
            } else {
              if (isRtl) {
                let dpLeft = $drop.offset().left, dt = acLeft - dpLeft;
                if (dt > 0) $drop.css({ right: -dt });
              } else {
                let dpWidth = $drop.outerWidth(), dpLeft = $drop.offset().left, dpRight = dpLeft + dpWidth,
                  dt = dpRight - acRight;
                if (dt > 0) $drop.css({ left: -dt });
              }
            }
            $drop.css({ display: '', opacity: '', visibility: '' });
          });
        }
      }
      alignVerDropdown() {
        if (!this.isHorMenu() && !this.isFullMenu() && (window.innerWidth >= 768)) {
          $('.js-items > .mn-item > .mn-items', this.element).each(function () {
            var $drop = $(this), $pr = $drop.parent(), $a = $pr.find(' > .mn-link').first();
            $pr.hover(function () {
              var drTop = $drop.offset().top, dpHeight = $drop.outerHeight(), wTop = $win.scrollTop(), wHeight = $win.innerHeight(),
                drBottom = drTop + dpHeight, wBottom = wTop + wHeight;
              $drop.css('top', Math.min(wBottom - drBottom, 0));
            }, function () { $drop.css('top', ''); });
          });
        }
      }
      isTouchDevice() {
        return this.element.hasClass('cdz-m-menu');
      }
      addTouchLinks() {
        var self = this, conf = this.options;
        $('li.mn-item.parent', self.element).each(function () {
          var $li = $(this), $a = $li.children('a').first(), href = $a.attr('href'), $ul = $li.children('.mn-items').first(), $aClone = $a.clone(); $aClone.find('.mn-tag').remove();
          var aText = $aClone.text(); $aClone.remove();
          if ((href.indexOf('#') === -1) && (href.indexOf('javascript:') === -1)) {
            let tText = conf.touchText.replace('%1', aText),
              $tLi = $('<li class="mn-t-item">').prependTo($ul), $tA = $('<a class="mn-t-link">').attr('href', href).html(tText).appendTo($tLi);
          }
          var bText = conf.backText.replace('%1', aText),
          $backLi =  $('<li class="mn-b-item">').prependTo($ul), $backA = $('<a class="mn-b-link">').on('click', function(e) {
            e.preventDefault();
            $li.removeClass('active');
          }).html(bText).appendTo($backLi);
          $a.on('click', function (e) {
            if (self.isTouchDevice()) {
              e.preventDefault();
              if (self.element.hasClass('cdz-m-menu')) {
                $li.toggleClass('active').siblings().removeClass('active');
              }
            }
          });
        });
      }
      hideOverflowingItems() {
        var self = this, conf = this.options, $el = self.element, $ul = $('.js-items', $el).first().css('display', ''),
        p2A = 'mn-p2-active';
        $('> .mn-p-two > .mn-item', $el).appendTo($ul); $el.removeClass(p2A);
        var $li = $('> .mn-item', $ul), $p2 = $('> .mn-p-two', $el).hide(), $pTg = $('> .mn-p-toggle', $el).addClass('hidden');
        if (!$p2.length) {
          $pTg = $('<div class="mn-p-toggle fa-sharp fa-solid hidden">').appendTo($el);
          $p2 = $('<ul class="mn-p-two">').addClass($ul.attr('class')).hide().appendTo($el);
          $pTg.on('click', () => {
            var isP2 = $el.hasClass(p2A), $visible = isP2 ? $p2 : $ul, $hidden = isP2 ? $ul : $p2;
            $visible.fadeToggle(300, 'swing', () => {
              $hidden.fadeToggle(300, 'swing', () => {
                $hidden.css('display', '');
                $el.trigger('menuPageChanged');
              });
              $el.toggleClass(p2A);
            });
          });
        }
        var getOvfIndex = () => {
          var lisW = 0, ovfId = -1, ulW = parseInt($ul.innerWidth());
          $li.each((i, li) => {
            lisW += parseInt($(li).outerWidth(true));
            if (lisW > ulW) {
              ovfId = i; return false;
            }
          });
          return ovfId;
        }, ovfId = getOvfIndex();
        if ((ovfId > -1) && (window.innerWidth >= conf.hBreakpoint)) {
          $('> .mn-item:gt(' + (ovfId - 2) + ')', $ul).appendTo($p2);
          $pTg.removeClass('hidden');
        }
        $el.trigger('menuHideOvf');
      }
    });
  }
})(jQuery)